module.exports = __webpack_public_path__ + "img/2.011d607b.jpg";